import intersection from 'lodash/intersection';
import { useCallback } from 'react';

import { useOpQuery } from './useOpQuery';
import { useHasFeatures } from './useHasFeatures';

export const useIsRestrictedBySiteSpecificRole = (orgId: number) => {
  const { hasFeatures: orgHasUserSitePartitioningFeature } = useHasFeatures(
    orgId,
    ['userSitePartitioning'],
  );

  // Determine the sites the logged in user has access to
  const { data: orgSites } = useOpQuery({
    apiEndpointName: 'listSites',
    parameters: [orgId],
    select: (heliumResponse) => heliumResponse.json.data,
    enabled: Boolean(orgId && orgHasUserSitePartitioningFeature),
  });

  // Need to wrap in useCallback to avoid rerenders (specifically Building > Units > edit)
  return useCallback(
    (userSiteIds?: number[]) => {
      const orgSiteIds = (orgSites || []).map(({ id }: { id: number }) => id);

      // If the org doesn't have the userSitePartitioning feature, the user is not restricted
      if (!orgHasUserSitePartitioningFeature) return false;

      // If the user has no site associations, the user is not restricted
      if (!userSiteIds?.length) return false;

      // If the user has site associations but none match the logged in user's org's sites, the user is restricted
      return intersection(userSiteIds, orgSiteIds).length === 0;
    },
    [orgHasUserSitePartitioningFeature, orgSites],
  );
};
